"use strict";

/**
* Реквизит карточки типа «Признак».
* 
* @class WebAccess.components.wrappers.form.requisites._details.Pick
* @extends WebAccess.components.wrappers.form.requisites.Pick
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @since 5.2.0.1300
* @private
*/
(function (global) {

  const Pick = global.Pick.extend([global._details.editModeMixin], {
    className: 'DetailPick',
 
    /**
    * Указать справочник, выбор из которого будет выполняться в первую очередь.
    *
    * @method WebAccess.components.wrappers.form.requisites._details.Reference#setMainReference
    * @param {string} referenceName Справочник, выбор из которого будет выполняться в первую очередь
    * @return {WebAccess.components.wrappers.form.requisites._details.Reference} Объект типа Reference.
    * @since 5.2.0.1300
    */
    
    clearValues: function(referenceName) {
      var me = this;
      me._clearPick = true;
      me._pickValues = [];

      if (me.isEditMode) {
        me._super(referenceName);
      }
      return me;
    },

    addValue: function (value, displayValue, opt_isDisabled) {
      var me = this;
      me._pickValues.push([value, displayValue, opt_isDisabled]);

      if (me.isEditMode) {
        me._super(value, displayValue, opt_isDisabled);
      }
      return me;
    }
  });

  global._details.Pick = Pick;
})(window.WA.CMP.wrappers.form.requisites);


